(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toInt = (value, fallback) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const addDays = (date, days, skipWeekends) => {
      const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (!skipWeekends || (day !== 0 && day !== 6)) added += 1;
      }
      return result;
    };

    const formatDate = (date) => new Intl.DateTimeFormat(undefined, {
      month: 'short',
      day: 'numeric'
    }).format(date);

    const formatRange = (start, end) => {
      if (start.getTime() === end.getTime()) return formatDate(start);
      return `${formatDate(start)} – ${formatDate(end)}`;
    };

    const initDelivery = (root = document) => {
      root.querySelectorAll('[data-st-delivery]').forEach((element) => {
        const processingMin = toInt(element.dataset.processingMin, 1);
        const processingMax = Math.max(processingMin, toInt(element.dataset.processingMax, 2));
        const transitMin = toInt(element.dataset.transitMin, 2);
        const transitMax = Math.max(transitMin, toInt(element.dataset.transitMax, 5));
        const skipWeekends = element.dataset.skipWeekends === 'true';
        const today = new Date();

        const shipStart = addDays(today, processingMin, skipWeekends);
        const shipEnd = addDays(today, processingMax, skipWeekends);
        const arrivalStart = addDays(shipStart, transitMin, skipWeekends);
        const arrivalEnd = addDays(shipEnd, transitMax, skipWeekends);

        const orderNode = element.querySelector('[data-st-order-date]');
        const shipNode = element.querySelector('[data-st-ship-date]');
        const arrivalNode = element.querySelector('[data-st-arrival-date]');

        if (orderNode) orderNode.textContent = formatDate(today);
        if (shipNode) shipNode.textContent = formatRange(shipStart, shipEnd);
        if (arrivalNode) arrivalNode.textContent = formatRange(arrivalStart, arrivalEnd);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initDelivery());
    } else {
      initDelivery();
    }

    document.addEventListener('shopify:section:load', (event) => initDelivery(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
